import React from 'react';
import { Info } from 'lucide-react';

// 评分参数配置页面
// 页面结构：说明提示 + 基础互评参数 + 恶意打分防范与处理机制 + 保存按钮
export default function ScoringParameterConfigPage() {
  return (
    <div className="animate-fade-in h-full">
      <div className="bg-white rounded shadow-sm border border-gray-100 min-h-full p-6 pb-24 relative">
        {/* 页面说明提示 */}
        <div className="mb-6 px-4 py-3 bg-[#eaf4ff] border border-[#d3e8ff] rounded text-sm text-[#1677ff] flex items-start gap-2 max-w-[900px]">
          <Info size={16} className="mt-0.5 shrink-0" />
          <span>
            互评规则将在生成互评任务时作为计算依据。请在生成任务前确认配置，历史任务不自动重算。
          </span>
        </div>

        <div className="max-w-[900px] space-y-5">
          {/* 基础互评参数卡片 */}
          <ConfigSection
            title="基础互评参数"
            markerClass="bg-[#1890ff]"
          >
            <ConfigInput
              label="互评人数比例"
              defaultValue="30"
              suffix="%"
              description="按班级人数比例自动生成每位学生需要评价的人数。"
            />
          </ConfigSection>

          {/* 恶意打分防范与处理机制卡片 */}
          <ConfigSection
            title="恶意打分防范与处理机制"
            markerClass="bg-red-500"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-5">
              <ConfigInput
                label="低分判定标准"
                defaultValue="1"
                prefix="打分值 ≤"
                suffix="分"
                description="低于或等于该分值的互评分将计入低分统计。"
              />

              <ConfigInput
                label="恶意参评比例阈值"
                defaultValue="50"
                suffix="%"
                description="低分占比超过该阈值后，系统判定为疑似恶意打分。"
              />
            </div>
          </ConfigSection>
        </div>

        {/* 底部保存按钮区 */}
        <div className="absolute bottom-0 left-0 right-0 p-5 bg-white border-t border-gray-100 flex justify-center">
          <button className="px-10 py-2.5 bg-[#1890ff] text-white rounded text-sm hover:bg-[#096dd9] font-medium">
            保存配置参数
          </button>
        </div>
      </div>
    </div>
  );
}

// 参数分组卡片
function ConfigSection({ title, markerClass, children }) {
  return (
    <div className="border border-gray-100 rounded bg-white shadow-sm p-5">
      <div className="flex items-center gap-2 mb-5">
        <span className={`w-1 h-4 rounded ${markerClass}`} />
        <h3 className="text-[15px] font-bold text-gray-900">
          {title}
        </h3>
      </div>
      {children}
    </div>
  );
}

// 参数输入项
function ConfigInput({
  label,
  defaultValue,
  prefix = '',
  suffix = '',
  description,
}) {
  return (
    <div>
      <label className="block">
        <span className="block mb-2 text-sm text-gray-800">
          {label}：
        </span>
        <div className="flex items-center">
          {prefix && (
            <span className="px-3 py-2 border border-r-0 border-gray-300 rounded-l bg-gray-50 text-sm text-gray-600">
              {prefix}
            </span>
          )}
          <input
            type="number"
            defaultValue={defaultValue}
            className={`${prefix ? 'rounded-none' : 'rounded-l'} border border-gray-300 px-3 py-2 w-[120px] text-sm outline-none focus:border-[#1890ff]`}
          />
          {suffix && (
            <span className="px-3 py-2 border border-l-0 border-gray-300 rounded-r bg-gray-50 text-sm text-gray-600">
              {suffix}
            </span>
          )}
        </div>
      </label>
      <div className="mt-2 text-xs text-gray-400">
        {description}
      </div>
    </div>
  );
}
